import store from '../store/index.js';
import { logout } from './auth.js';

const HTTP_UNAUTHORIZED = 401;
const HTTP_NOT_FOUND = 404;
const HTTP_CONFLICT = 409;
const HTTP_SERVER_ERROR = 500;

export const STATUS_ERROR = 'ERROR';
export const STATUS_OK = 'OK';

async function do_fetch(path, conf) {
    const headers = [['Content-Type', 'application/json']];

    const token = store.state.authToken;
    if (token) {
        headers.push(['Authorization', `Bearer ${token}`]);
    }

    conf.headers = headers;
    let ret;
    try {
        ret = await fetch(`/api${path}`, conf);
    } catch (e) {
        if (e instanceof DOMException) {
            // The map call has cancelled a request in progress, this is normal
            console.debug('Fetch aborted:', path);
            return {
                status: STATUS_ERROR,
                msg: 'requestAborted',
                msg_data: null,
                payload: null,
            };
        } else {
            console.error(e);
            return {
                status: STATUS_ERROR,
                msg: 'networkError',
                msg_data: null,
                payload: null,
            };
        }
    }

    // Check for 'unauthorized'
    if (ret.status === HTTP_UNAUTHORIZED) {
        // Only force logout if this 401 corresponds to the still-active token.
        if (token && store.state.authToken === token) {
            logout();
        }
        return undefined;
    }

    // Check for 'not found'
    if (ret.status === HTTP_NOT_FOUND) {
        console.debug(`${path}: NOT FOUND`);
        return {
            status: STATUS_ERROR,
            msg: 'endpointNonExistent',
            msg_data: { path },
            payload: null,
        };
    }

    if (ret.status === HTTP_CONFLICT) {
        console.warn(`${path}: HTTP_CONFLICT`);
        const js = await response_json(ret);
        return js;
    }

    // Check for 'server error'
    if (ret.status === HTTP_SERVER_ERROR) {
        console.warn(`${path}: HTTP_SERVER_ERROR`);
        const js = await response_json(ret);
        return js;
    }

    const js = await response_json(ret);
    return js;
}

async function response_json(response) {
    let js = {
        status: STATUS_ERROR,
        msg: 'serverError',
        msg_data: null,
        payload: null,
    };

    try {
        js = await response.json();
    } catch (ex) {
        console.debug('client response.json exception: ', ex);
        return js;
    }

    return js;
}

export async function get(path, abortController) {
    if (abortController) {
        return do_fetch(path, {
            method: 'GET',
            signal: abortController.signal,
        });
    } else {
        return do_fetch(path, { method: 'GET' });
    }
}

export async function post(path, body, signal) {
    return do_fetch(path, {
        method: 'POST',
        body: body ? JSON.stringify(body) : undefined,
        ...(signal ? { signal } : {}),
    });
}

async function _delete(path) {
    return do_fetch(path, { method: 'DELETE' });
}

export { _delete as delete };
